import { Component, defineComponent } from 'vue';

import {
	SelectedFilters,
	SearchFilterContainer,
	AttendanceFilter,
	CertificationTypeFilter,
	DisciplineFilter,
	DurationFilter,
	EducationalFormFilter,
	FormatFilter,
	LocationFilter,
	SpecialProgrammesFilter,
	TuitionFeeFilter,
} from '@studyportals/search-filters';

export default defineComponent({
	components: {
		SelectedFilters: SelectedFilters as Component,
		SearchFilterContainer: SearchFilterContainer as Component,
		DisciplineFilter: DisciplineFilter as Component,
		LocationFilter: LocationFilter as Component,
		CertificationTypeFilter: CertificationTypeFilter as Component,
		EducationalFormFilter: EducationalFormFilter as Component,
		DurationFilter: DurationFilter as Component,
		FormatFilter: FormatFilter as Component,
		AttendanceFilter: AttendanceFilter as Component,
		SpecialProgrammesFilter: SpecialProgrammesFilter as Component,
		TuitionFeeFilter: TuitionFeeFilter as Component,
	},
});
